import { h, Host } from "@stencil/core";
/**
 * The `ux-headline` component is used to display headlines.
 * @slot - The default slot where headline content is placed.
 * @internal Currently only for usage in web-apps.
 */
export class Headline {
    constructor() {
        this.variant = "medium";
        this.level = undefined;
        this.strong = undefined;
    }
    render() {
        return (h(Host, { key: '570b0320a4a693b7ed28daee2300b64cc72424eb', role: "heading", "aria-level": this.level }, h("slot", { key: '59f85f4cb23371b6b34975b48c77638872c7619e' })));
    }
    static get is() { return "ux-headline"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["headline.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["headline.css"]
        };
    }
    static get properties() {
        return {
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"vast\" | \"giant\" | \"big\" | \"medium\" | \"small\"",
                    "resolved": "\"big\" | \"giant\" | \"medium\" | \"small\" | \"vast\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The variant of the headline."
                },
                "attribute": "variant",
                "reflect": true,
                "defaultValue": "\"medium\""
            },
            "level": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The level of the headline.\n1 = H1\n2 = H2\n..."
                },
                "attribute": "level",
                "reflect": true
            },
            "strong": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Whether the headline should be strong."
                },
                "attribute": "strong",
                "reflect": true
            }
        };
    }
}
//# sourceMappingURL=headline.js.map
